import { render } from "./BlockFrame.vue?vue&type=template&id=1b73be92&scoped=true"
import script from "./BlockFrame.vue?vue&type=script&lang=js"
export * from "./BlockFrame.vue?vue&type=script&lang=js"

import "./BlockFrame.vue?vue&type=style&index=0&id=1b73be92&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/AcivgTheme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b73be92"]])

export default __exports__